"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useLoadReadinessCheckerSLI = require("./useLoadReadinessCheckerSLI");
Object.keys(_useLoadReadinessCheckerSLI).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useLoadReadinessCheckerSLI[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useLoadReadinessCheckerSLI[key];
    }
  });
});